import { Component, ParentComponent } from "solid-js";

interface ReviewSectionWrapperProps {
  title: string;
}

export const ReviewSectionWrapper: ParentComponent<
  ReviewSectionWrapperProps
> = (props) => {
  return (
    <section
      data-testid={`review-section-${props.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "")}`}
    >
      <h3 class="mt-0 mb-FsSpacing2x text-FsFontSize0875x tracking-wider uppercase font-FsFontWeightRegular @xs:font-FsFontWeightSemibold">
        {props.title}
      </h3>
      {props.children}
    </section>
  );
};

export const ReviewSectionDivider: Component = () => {
  return (
    <fd-mfe-divider
      class="py-FsSpacing1x @xs:py-FsSpacing3x"
      prop:emphasis="low"
    />
  );
};
